module.exports = __webpack_public_path__ + "static/media/Gif_Eye.b3a33fe6.gif";